import { SchedulerDayColumn, ShiftSiblingData } from '@lp/features/Scheduler/types';
import { DayCell } from '@lp/features/Scheduler/components';
import { CSShiftCell, CSShiftEmptyCell } from '@lp/features/Scheduler/SchedulerClinicalSpecialists/components';
import { CSResource, CSShift, CSShiftSelectPayload } from '@/api/apis/resources/schedule';

type DayCellProps = {
  column: SchedulerDayColumn;
  resource?: CSResource;
  shiftData: CSShift;
  prevShift?: CSShift;
  prevLighten?: boolean;
  prevIsExternal?: boolean;
  siblingData?: ShiftSiblingData;
  isEditable: boolean;
  canReset: boolean;
  highlight?: boolean;
  canUnblock?: boolean;
  usesDeductionRules?: boolean;
  onShiftChange: (shiftPayload?: CSShiftSelectPayload) => void;
  onUnblock?: () => void;
};

export const CSDayCell = ({
  column,
  resource,
  shiftData,
  prevShift,
  prevLighten,
  prevIsExternal,
  siblingData,
  isEditable,
  canReset,
  highlight,
  canUnblock,
  usesDeductionRules,
  onShiftChange,
  onUnblock,
}: DayCellProps) => {
  const readonly = !isEditable || !column.isCurrentMonth;

  return (
    <DayCell
      active={column.isSelectedDay}
      highlight={highlight}
      hasPrev={siblingData?.hasPrev}
      hasNext={siblingData?.hasNext}
    >
      {shiftData ? (
        <CSShiftCell
          shiftData={shiftData}
          prevShift={prevShift}
          prevIsExternal={prevIsExternal}
          siblingData={siblingData}
          lighten={!column.isCurrentMonth}
          prevLighten={prevLighten}
          readonly={readonly}
          canReset={canReset}
          resource={resource}
          canUnblock={canUnblock}
          usesDeductionRules={usesDeductionRules}
          onShiftChange={onShiftChange}
          onUnblock={onUnblock}
        />
      ) : (
        !readonly && (
          <CSShiftEmptyCell resource={resource} usesDeductionRules={usesDeductionRules} onShiftChange={onShiftChange} />
        )
      )}
    </DayCell>
  );
};
